import {
    faComments,
    faPencilAlt,
    faPlusCircle,
    faShoppingBasket,
    faSoup,
    faStar,
} from "@fortawesome/pro-solid-svg-icons";
import { Location } from "history";
import React from "react";
import { connect } from "react-redux";

import { analyticsStoreEvent } from "@/mk2/actions";
import { bazaarCreateProductUrl } from "@/mk2/apps/bazaar/urls";
import {
    blogsProfileRedirectUrl,
    blogsProfileUrl,
    blogsRecipeArticleCreateUrl,
} from "@/mk2/apps/blogs/urls";
import { OTHER_CATEGORY_SLUG, UNCATEGORIZED_TOPIC_SLUG } from "@/mk2/apps/forum/constants";
import { forumPostNewInTopicUrl } from "@/mk2/apps/forum/urls";
import { loginUrl } from "@/mk2/apps/users/urls";
import { wikiAddExperienceToUndefinedArticleUrl } from "@/mk2/apps/wiki/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { MenuItem } from "@/mk2/components/menu/MenuItem";
import { Menu } from "@/mk2/containers/Menu/Menu";
import { menuToggle } from "@/mk2/containers/Menu/Menu.actions";
import { hasRequiredPermissions } from "@/mk2/helpers/permissions";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { url } from "@/mk2/helpers/urls";
import { AppState } from "@/mk2/reducers";
import { UserEntity } from "@/mk2/schemas";
import {
    ADD_MENU_ADD_BAZAAR_PRODUCT,
    ADD_MENU_ADD_BLOG_POST,
    ADD_MENU_ADD_DISCUSSION,
    ADD_MENU_ADD_REVIEW,
    ADD_MENU_SUBTITLE_AD,
    ADD_MENU_SUBTITLE_DISCUSSION,
    ADD_MENU_SUBTITLE_POST,
    ADD_MENU_SUBTITLE_RECIPE,
    ADD_MENU_SUBTITLE_REVIEW,
    ADD_RECIPE,
    HOMEPAGE_ADD_BUTTON,
} from "@/mk/autogenerated/translation";
import { RECIPE_TESTERS_PERMISSIONS, isAuthenticated } from "@/mk/bazaar/common/userUtils";

export const MENU_ID = "add-menu";

interface OwnProps {
    className?: string;
    buttonLabel?: string;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    location: Location;
}
interface StateProps {}
interface DispatchProps {
    onToggleMenuMore();
    onStoreEvent(name: string, props: any);
}

export type Props = OwnProps & StateProps & DispatchProps;

export class AddMenu extends React.Component<Props> {
    public render() {
        const { onToggleMenuMore, className, buttonLabel, requestUser, requestUserPermissions } =
            this.props;

        return (
            <Menu
                menuId={MENU_ID}
                className={className}
                trigger={
                    <Btn
                        type={BtnType.Blue}
                        icon={faPlusCircle}
                        label={buttonLabel || HOMEPAGE_ADD_BUTTON}
                        onClick={this.handleButtonClick}
                    />
                }
            >
                <MenuItem
                    label={ADD_MENU_ADD_DISCUSSION}
                    subtitle={ADD_MENU_SUBTITLE_DISCUSSION}
                    icon={faComments}
                    link={url(forumPostNewInTopicUrl, {
                        categorySlug: OTHER_CATEGORY_SLUG,
                        topicSlug: UNCATEGORIZED_TOPIC_SLUG,
                    })}
                />
                <MenuItem
                    label={ADD_MENU_ADD_BLOG_POST}
                    subtitle={ADD_MENU_SUBTITLE_POST}
                    icon={faPencilAlt}
                    link={
                        isAuthenticated(requestUser)
                            ? url(blogsProfileUrl, { username: requestUser.username }) +
                              "#pb-message-form"
                            : url(
                                  loginUrl,
                                  {},
                                  { next: `${blogsProfileRedirectUrl}#pb-message-form` },
                              )
                    }
                    asAnchor
                />
                <MenuItem
                    label={ADD_MENU_ADD_BAZAAR_PRODUCT}
                    subtitle={ADD_MENU_SUBTITLE_AD}
                    icon={faShoppingBasket}
                    link={bazaarCreateProductUrl}
                />
                <MenuItem
                    label={ADD_MENU_ADD_REVIEW}
                    subtitle={ADD_MENU_SUBTITLE_REVIEW}
                    icon={faStar}
                    link={wikiAddExperienceToUndefinedArticleUrl}
                />
                {isAuthenticated(requestUser) &&
                    hasRequiredPermissions(requestUserPermissions, RECIPE_TESTERS_PERMISSIONS) && (
                        <MenuItem
                            label={`${ADD_RECIPE} (beta)`}
                            subtitle={ADD_MENU_SUBTITLE_RECIPE}
                            icon={faSoup}
                            link={url(blogsRecipeArticleCreateUrl, {
                                username: requestUser.username,
                            })}
                            onClick={this.handleRecipeCreateClick}
                        />
                    )}
            </Menu>
        );
    }

    private handleButtonClick = () => {
        const { onToggleMenuMore, onStoreEvent } = this.props;
        onToggleMenuMore();
        onStoreEvent("hp_add_button_click", {});
    };

    private handleRecipeCreateClick = () => {
        const { onStoreEvent } = this.props;
        onStoreEvent("recipes_create_click", { source: "add_menu" });
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {};
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onToggleMenuMore: () => menuToggle(MENU_ID),
    onStoreEvent: analyticsStoreEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenu);
